import type { FooterProps } from "./types";

import Link from "@/components/link";
import { EnvelopeClosedIcon } from "@navikt/aksel-icons";

export default function Footer(props: FooterProps) {
	return (
		<>
			{props.email && (
				<Link
					href={`mailto:${props.email}`}
					className="w-fit text-white hover:text-main-base-contrast-subtle"
				>
					<EnvelopeClosedIcon aria-hidden="true" />
					<span>{props.email}</span>
				</Link>
			)}

			{props.socials?.facebook && (
				<Link
					href={props.socials.facebook}
					className="w-fit text-white hover:text-main-base-contrast-subtle"
				>
					<svg viewBox="0 0 40 40" aria-hidden="true">
						<use href="/assets/svg/icons-some.svg#icon-facebook" />
					</svg>
					<span>Følg oss på Facebook</span>
				</Link>
			)}
			{props.socials?.x && (
				<Link
					href={props.socials.x}
					className="w-fit text-white hover:text-main-base-contrast-subtle"
				>
					<svg viewBox="0 0 38 38" aria-hidden="true">
						<use href="/assets/svg/icons-some.svg#icon-x" />
					</svg>
					<span>Følg oss på X/Twitter</span>
				</Link>
			)}

			{props.socials?.instagram && (
				<Link
					href={props.socials.instagram}
					className="w-fit text-white hover:text-main-base-contrast-subtle"
				>
					<svg viewBox="0 0 40 40" aria-hidden="true">
						<use href="/assets/svg/icons-some.svg#icon-instagram" />
					</svg>
					<span>Følg oss på Instagram</span>
				</Link>
			)}
		</>
	);
}